import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import ChatList from '../v2/ChatList';
import MessengerChatDetail from '../messenger/v2/MessengerChatDetail';
import ChatSearchBar from '../v2/ChatSearchBar';
import StatsBar from '../StatsBar';
import StatsTable from '../StatsTable';
import Modal from '../Modal';
import Loading from '../Loading';
import { connectWebsocket, deselectFeedback } from '../redux/FeedbackRedux';
import FitlerMessageBar from '../v2/FilterMessageBar';
import FeedbackDetail from '../v2/FeedbackDetail';
import FeedbackDetailBar from '../v2/FeedbackDetailBar';

class Messenger extends React.Component {
    // componentDidMount() {
    //     this.props.dispatch(connectWebsocket());
    //     this.props.dispatch(setSelectedFeedback(this.props.state.selected_feedback));
    // }

    render() {
        return (
            <div className="container-fluid">
                <Loading location={'page'} />
                {this.props.state.feedback_detail == null &&
                    <div className="row">
                        <ChatSearchBar title="All Chats" />
                    </div>
                }

                <div className="feedbacks" >
                    {this.props.state.feedback_detail == null &&
                        <>
                            <div className='mb-3 w-100'><FitlerMessageBar /></div>
                            <ChatList />
                        </>
                    }
                    {this.props.state.feedback_detail != null &&
                        <>
                            <FeedbackDetailBar toggleChat={() => { this.props.dispatch(deselectFeedback());}} showChat={true} chatPage />
                            <FeedbackDetail />
                        </>

                    }

                    {!this.props.state.initial_feedbacks.length &&
                        <div className="col-md-12 nonefound">
                            <h5 className="text-center">{__('No Chats Found')}...</h5>
                        </div>
                    }
                </div>
                <Modal modal={this.props.state.modal} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(Messenger);
